module.exports = __webpack_public_path__ + "static/img/jiat-innovation02.356d652.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/jiat-innovation02.jpg
// module id = it9u
// module chunks = 0